<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="segcompilar"></p-toast>
<!-- <p-confirmDialog [transitionOptions]="'0ms'" key="contdocConf" title="Confirmar Acción" appendTo="body">
</p-confirmDialog> -->
<div class="p-grid" style="width: 98%">
	<div class="p-col-12">
		<app-invmaebarra [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true"
						 [barraBotones5]="true" [botonVisto]="false" [barraBotonesCRUD]="true" [barraBotones3Alt]="false"
						 (signal)="manejarSenales($event)"
						 style="text-align: left;">
		</app-invmaebarra>
	</div>
</div>

<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <!-- <div class="contorno" id="contorno"> -->
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-2">
                            <span>Tipo:</span>
                        </div>
                        <div class="p-col-3">
                            <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="strTipo"
                                        optionLabel="name" [options]="cmbTipo" [panelStyle]="{'width':'100%'}"
                                        inputId="tipoBanMovCaj">
                            </p-dropdown>
                        </div> 
                        <div class="p-col-1">
                            <button (click)="consultar()" pButton class="aceptar"
                                    style="line-height: 2.5em; font-family: Arial, serif; margin-top: -5px; height: 30px; width: 100px; ">
                                Visualizar
                            </button>
                        </div>                   
                        <div class="p-col-2" style="text-align: left;">
                            <p-checkbox binary="true" label="Seleccionar Todos"
                                        [(ngModel)]="segcompilaSeleccionarTodo"
                                        (click)="seleccionarTodo()">
                            </p-checkbox>
                        </div>
                    </div>
                </div>
            <!-- </div> -->
            <app-aggridsaci 
            [width]=""
            [height]="150" 
            [enableSorting]="true" 
            [enableFilter]="true"
            [rowData]="detreg" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsregcompilar"
            [defaultColDef]="defaultregcompilar" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="false"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
            [solobotoneliminar]="true"
           
            (selected)="seleccionItem($event)" 
            [tipodetalle]=""
            [CC]="true">
            </app-aggridsaci>
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>